import Cache from '../utils/Cache';

const cache = new Cache(localStorage);

export const superBookTokenCache = cache.cursor('SUPER_BOOK_TOKEN');
export const storeIdCache = cache.cursor('storeId');

export default cache;
